<template>
  <panel :title="detailsUser" :withBody="false" :withFooter="false">
    <div slot="header-right">
      <div class="form-flex">
        <span v-if="this.user.role" class="badge badge-default">{{ $t(this.user.role.identifier).label }}</span>
        <button-actions :identifier="`user-item-actions-${user._id.$oid}`">
          <li>
            <span v-if="hasAdminAccess" @click="showModalUserRoles()"><i class="fa fa-lock"></i> Perfil de Acesso</span>
            <span @click="showModal()">Desvincular usuário</span>
          </li>
        </button-actions>
      </div>
    </div>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import ButtonActions from '@/components/template/ButtonActions'

  export default {
    props: {
      user: {
        type: Object,
        required: true
      },
      hasAdminAccess: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      detailsUser () {
        return `${this.user.email}`
      }
    },
    methods: {
      showModal () {
        this.$parent.$parent.showModal(this.user)
      },
      showModalUserRoles () {
        this.$parent.$parent.showModalUserRoles(this.user)
      }
    },
    components: {
      Panel,
      ButtonActions
    }
  }
</script>

<style lang="sass" scoped>
  i
    color: #808080

  .form-flex
    display: inline

  .progress
    margin: 0
    -webkit-border-radius: 0
    -moz-border-radius: 0
    border-radius: 0

  .product
    border: 0

  .progress[value]::-ms-fill
    border: none
    background-color: #800080 !important

  .progress[value]::-webkit-progress-bar
    background-color: #f2f2f2

  .progress[value]::-webkit-progress-value
    background-color: #800080 !important

  .progress[value]::-moz-progress-bar
    background-color: #800080 !important
</style>



// WEBPACK FOOTER //
// Card.vue?cea7696c